/**
 * Run 7 structure (decision 90): the cart drawer cross-sell's Add button.
 * Adds the variant through Horizon's own cart action (Shopify.actions.updateCart), so the drawer, the cart count and
 * the free-delivery line re-render exactly as they do after any other add. Without the action (or if it fails) the
 * form submits normally to /cart/add. Focus moves to the drawer heading once the drawer has re-rendered, because the
 * button itself is replaced.
 */
document.addEventListener('submit', async (event) => {
  const form = event.target instanceof HTMLFormElement && event.target.matches('form[data-cn-xsell]') ? event.target : null;
  if (!form) return;
  const updateCart = window.Shopify?.actions?.updateCart;
  if (typeof updateCart !== 'function') return;
  event.preventDefault();
  const button = form.querySelector('button');
  const variantId = /** @type {HTMLInputElement} */ (form.elements.namedItem('id'))?.value;
  if (!variantId) return form.submit();
  button?.setAttribute('aria-busy', 'true');
  if (button) button.disabled = true;
  try {
    const result = await updateCart({ lines: [{ merchandiseId: variantId, quantity: 1 }] });
    if (result && Array.isArray(result.userErrors) && result.userErrors.length) throw new Error(result.userErrors[0].message);
    // the drawer re-renders after the action resolves; once this form has been replaced, focus the drawer heading
    const started = performance.now();
    const replaced = () => !form.isConnected || /** @type {HTMLInputElement} */ (form.elements.namedItem('id'))?.value !== variantId;
    const settle = () => {
      if (!replaced() && performance.now() - started < 3000) return requestAnimationFrame(settle);
      if (!replaced()) { button?.removeAttribute('aria-busy'); if (button) button.disabled = false; return; }
      const heading = document.getElementById('cart-drawer-heading');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    };
    requestAnimationFrame(settle);
  } catch (error) {
    form.submit();
  }
});
